export class CheckoutSessionDTO{
    priceId: string = '';

    constructor(data: Partial<CheckoutSessionDTO> = {}){
        Object.assign(this,data);
    }
}